module.exports = __webpack_public_path__ + "static/media/image-left.9eed84c4.png";